import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { formatLocale } from '../../../helpers/formatLocale';

import addIcon from '../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../public/Icons/deleteIocn.svg';

import s from './FooterSettingsForm.css';
import bt from '../../../components/commonStyle.css';

export class FooterSettingsForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedLanguages: []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { dynamicFooterTitle } = nextProps;
        let filteredLanguages = dynamicFooterTitle?.map((item) => { return item?.language })
        this.setState({ selectedLanguages: filteredLanguages });
    }

    renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, inputClassname }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className={inputClassname}>
                {label && <label className={bt.labelText} >{label}</label>}
                <Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} />
                {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }
    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl
        return (
            <div>
                <FormGroup className={cx(s.formGroup, 'noMargin')}>
                    <div>
                        <label className={bt.labelText} >{label}</label>
                    </div>
                    <div>
                        <FormControl
                            {...input}
                            className={className}
                            placeholder={label}
                            as="textarea"
                            rows="3"
                        >
                            {children}
                        </FormControl>
                        {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
                    </div>
                </FormGroup>
            </div>
        );
    }

    renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
        const { formatMessage } = this.props.intl;
        return (
            <div className={bt.space5}>
                {label && <label className={bt.labelText} >{label}</label>}
                <FormControl as="select" {...input} className={className} >
                    {children}
                </FormControl>
                {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
            </div>
        )
    }

    renderFieldArray = ({ fields, meta: { touched, error } }) => {
        const { formatMessage } = this.props.intl;
        const { languageList } = this.props;
        const { selectedLanguages } = this.state;

        return (
            <div className={bt.languageBox}>
                {
                    fields && fields?.map((item, index) => {
                        let fieldLength = fields.length - 1;
                        const currentLanguage = fields?.get(index)?.language;
                        const availableLanguages = languageList?.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
                        return (
                            <div key={index}>
                                <Row>
                                    <Col lg={6} md={6} sm={12} xs={12} className={bt.mb30Xs}>
                                        <Field name={`${item}.language`} component={this.renderFormControlSelect} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)} label={formatMessage(messages.language)}>
                                            <option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
                                            {availableLanguages?.map((locale, index) => {
                                                return (
                                                    <option value={locale} key={index}>{formatLocale(locale)}</option>
                                                )
                                            })}
                                        </Field>
                                        <Field name={`${item}.description`} component={this.renderFormControlTextArea} label={formatMessage(messages.footerContent1)} className={cx(bt.textAreaHeight)} />
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12} className={bt.noMargin}>
                                        <Field name={`${item}.value`} type="text" component={this.renderField} placeholder="Title" label={formatMessage(messages.footerTitle1)} inputClassname={'mb30'} />
                                        <Field name={`${item}.urlTitle`} type="text" component={this.renderField} placeholder="Title" label={formatMessage(messages.footerUrltitle)} inputClassname={'noMargin'} />
                                    </Col>
                                </Row>
                                <div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
                                    {(fields.length <= languageList?.length - 1) && fieldLength == index &&
                                        <Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
                                            <img src={addIcon} alt='addIcon' />
                                            <span>	{formatMessage(messages.addLanguage)}</span>
                                        </Button>
                                    }
                                    {index != 0 &&
                                        <div>
                                            <Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.remove(index)}>
                                                <img src={trashIcon} alt='addIcon' />
                                                <span>{formatMessage(messages.deleteLanguage)}</span>
                                            </Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    render() {
        const { handleSubmit, footerLogo1, footerLogo2, footerLogo3, footerLogo4, loading, submitting } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
                <div className={s.responsiveNoPadding}>
                    <Card className={s.card}>
                        <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                            <h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.footerSectionSettings)}</h1>
                            <Row>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className={cx(s.formGroup, 'mb30')}>
                                        <div>
                                            <Field name="footerBottom" type="text" component={this.renderField} label={formatMessage(messages.copyRightcontent)} inputClassname={bt.noMargin} />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <Form.Group className={cx(s.formGroup, 'mb0', bt.paddingTop5, bt.languageBtnDivider)}>
                                        <div>
                                            <FieldArray name="footerTitle1" type="text" component={this.renderFieldArray} />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL', 'loadingBtnRTL')}>
                                    <Form.Group className={s.formGroup}>
                                        <div className={s.displayInlineBlock}>
                                            <Loader
                                                type={"button"}
                                                label={formatMessage(messages.submitButton)}
                                                show={loading}
                                                buttonType={'submit'}
                                                className={cx(bt.btnPrimary, bt.clickBtn)}
                                                disabled={submitting || loading}
                                                isSuffix={true}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </div>
            </div>
        )
    }
}
FooterSettingsForm = reduxForm({
    form: 'FooterSettingsForm',
    onSubmit: submit,
    validate
})(FooterSettingsForm);
const selector = formValueSelector('FooterSettingsForm')
const mapState = (state) => ({
    footerLogo1: selector(state, 'footerLogo1'),
    footerLogo2: selector(state, 'footerLogo2'),
    footerLogo3: selector(state, 'footerLogo3'),
    footerLogo4: selector(state, 'footerLogo4'),
    loading: state?.loader?.SignupSettingsForm,
    dynamicFooterTitle: selector(state, 'footerTitle1'),
    languageList: state?.runtime?.availableLocales,
})
const mapDispatch = {

}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(FooterSettingsForm)));
